@if (showBanner) {
  <div class="cookie-banner">
    <div class="cookie-banner__content">
      <p class="cookie-banner__text">
        {{ 'cookies.banner.text' | translate }}
      </p>
      <button
        class="cookie-banner__button"
        type="button"
        (click)="acceptCookies()">
        {{ 'cookies.banner.accept' | translate }}
      </button>
    </div>
  </div>
}
